export class ExcludableList<T> {

  get items() {
    return this.excludables.map((x) => x.item);
  }

  constructor(public excludables: IExcludable<T>[] = []) {

  }
}

export interface IExcludable<T> {
  item: T;
  include: boolean;
}
